module.exports = __webpack_public_path__ + "static/25-7a84d097d3f625a9210971ced4ac01b9.jpg";